export const API="https://schooladmin-management.onrender.com"